import { combineEpics } from 'redux-observable';

import { updateGridBannerPriceCellEpic } from './banners-grid';
import {
    resetBannersPricesEpic,
    saveBannersPricesEpic,
    validateBannersPricesEpic
} from './banners-prices';
import {
    cancelBannersEpic,
    changeBannerTypeAttemptEpic,
    changeCopiedDisplayConditionsTooltipStatusEpic,
    changeOpenStateDisplayConditionsEpic,
    checkBannerHrefStatusEpic,
    checkBannerSitelinkHrefStatusEpic,
    checkBannersPromocodesEpic,
    clearBannersForEditBannerEpic,
    clearOrganizationsBannersEpic,
    copyKeywordsToClipboardEpic,
    copyOrganizationBannerEpic,
    createNewBannerEpic,
    createNewTextBannerEpic,
    fetchGroupKeywordsAndRetargetingsEpic,
    fetchVCardMetroStationEpic,
    getBannersAutoGeneratedVideosEpic,
    getBannersForEditEpic,
    getBaseInfoForBannerCreationEpic,
    getImageCanvasForEdit,
    getImagesForEdit,
    getModerationRejectReasons,
    getPerformanceCreativesEpic,
    getRecommendationsForBannersEditEpic,
    getTurbolandingInfoEpic,
    getTurbolandingInfoForSitelinkEpic,
    getVCardsForEditEpic,
    handleBannersEditMassActionsEpic,
    leaveBannersEditEpic,
    leavePerformanceBannerCreationEpic,
    onAddTextBannerEpic,
    onVideoCreativeCloseEpic,
    openRecommendationsModalForBannersEditEpic,
    prepareBannersBeforeSavingEpic,
    saveBannersEpic,
    saveSitelinksEpic,
    saveVisitingCardForEditBannerEpic,
    scrollToDuplicateBannerEpic,
    showBannerImagesErrorEpic,
    updateBannerCpcCreativeIdEpic,
    updateBannerCreativeIdEpic,
    updateBannerImagesFromGallery,
    updateBannersContactsForUserDomainEpic,
    updateBannersContactsForUserEpic,
    updateCpmBannerCreativeIdEpic,
    updateDraftSiteLinksEpic,
    updateLinkProtocolBannersContactsForUserEpic,
    updatePerformanceCreativesSearchFieldEpic,
    updateProtocolDraftSiteLinksEpic,
    uploadAdBannerImageByLinkEpic,
    uploadAdBannerImagesEpic,
    uploadBannerImageEpic,
    uploadTextBannerImageByLinkEpic,
    validateAdBannerImagesEpic,
    validateBannerImageFromGalleryEpic,
    validateBannerPriceEpic
} from './bannersEdit/bannersEdit';
import {
    onAcceptMassActionsCalloutsEditorEpic,
    onAcceptMassActionsImageEditorEpic,
    onAcceptMassActionSiteLinksDataEpic,
    onAcceptMassActionsLinkBulkPathReplacementEditorEpic,
    onAcceptMassActionsLinkBulkReplacementEditorEpic,
    onAcceptMassActionsLinkDisplayedBulkReplacementEditorEpic,
    onAcceptMassActionsVideoEditorEpic,
    onSaveMassActionsTextBulkReplacementEditorEpic
} from './bannersEdit/bannersEditMassAction/bannersEditMassAction';
import { AddCalloutsEpic, RemoveCalloutsEpic } from './callouts';
import {
    acceptCampaignAndGroupSelectorDataDnaEpic,
    acceptCampaignAndGroupSelectorDataEpic,
    fetchCampaignAndGroupSelectorCampaignsDataEpic,
    fetchCampaignAndGroupSelectorGroupsDataEpic,
    openCampaignAndGroupSelectorEpic,
    selectCampaignAndGroupSelectorCampaignEpic
} from './campaignAndGroupSelector';
import { updateCampaignDayBudgetEpic } from './campaigns-grid';
import {
    addEndDateForEditCampaignEpic,
    changeSiteMonitoringFlagForEditCampaignEpic,
    deleteEndDateForEditCampaignEpic,
    fetchCampaignsGoalsAvailableForKeyGoalsEpic,
    getCampaignsForEditEpic,
    getRetargetingConditionsForCampaignsEditEpic,
    leaveCampaignsEditEpic,
    saveCampaignChatEpic,
    saveCampaignExperimentsEditorEpic,
    saveCampaignMetrikaCountersEpic,
    saveCampaignMetrikaKeyGoalsEditorEpic,
    saveCampaignMinusPhrasesEditorEpic,
    saveCampaignNotificationEditorEpic,
    saveCampaignRateCorrectionEditorEpic,
    saveCampaignRelevantPhrasesEpic,
    saveCampaignsEpic,
    saveCampaignStrategyEditorEpic,
    saveCampaignTimeTargetingEditorEpic,
    saveVisitingCardForEditCampaignEpic,
    updateCampaignAllowedPageIdsEpic,
    updateCampaignBannedDomainsEpic,
    updateCampaignDisabledIpsEpic,
    updateCampaignMetrikaCountersEpic,
    updateCampaignNameEpic
} from './campaignsEdit/campaignsEdit';
import { chatListEditorEpic } from './chatListEditor/chatListEditor';
import { requestClientFreelancerDataEpic } from './clientFreelancerData';
import { requestClientMobileAppsDataEpic } from './clientMobileApps';
import {
    changeGoalsCheckedFromColumnsSettingsEditorEpic,
    columnsSettingsEditorEpic,
    openColumnsSettingsEditorEpic
} from './columnsSettingsEditor/columnsSettingsEditor';
import {
    changeLocationHardDataEpic,
    commonDataEpic,
    deleteCookieEpic,
    hideRecommendationTooltipEpic,
    onGridSourceParamsChangedEpic,
    redirectToLocationEpic,
    rejectRequestAuthorizationDataEpic,
    reloadLocationEpic,
    requestAuthorizationData,
    setCookieEpic,
    updateDocumentTitleEpic
} from './common';
import { onDeleteEndDateForDatesIntervalEditorEpic } from './datesIntervalEditor/datesIntervalEditor';
import {
    acceptRejectDealsEpic,
    clientsDealsLoadEpic,
    dealDetailEpic,
    loadDealsCampaignsEpic,
    requestDealsEpic,
    resetDealsDataEpic,
    updateDealsEpic,
    updateDealsSourceParamsEpic
} from './deals/deals';
import { dealsHelpersEpic } from './deals/deals-helpers';
import { dealsNavigationEpic } from './deals/deals-navigation';
import {
    doFakeAuthEpic,
    fetchClientDev,
    switchDumpVarsStateEpic,
    switchShowCaptchaStateEpic
} from './development-tools';
import {
    saveFeedFilterPriorityCellEpic,
    saveFeedFilterRateCellEpic,
    saveFeedFiltersAutobudgetPriorityEpic,
    saveFeedFiltersRateEpic,
    setInitialFeedFilterPriorityEpic,
    setInitialFeedFilterRateEpic
} from './feed-filters-grid';
import { freelancers } from './freelancers';
import { fetchGoalsDataEpic } from './goals/goals';
import {
    addEntitySuccessEpic,
    bindMinusPhraseToGridGroupsEpic,
    closeAlertGridErrorEpic,
    editEntitySuccessEpic,
    fetchAdjustmentInfoEpic,
    fetchGridGroupsCountsEpic,
    fetchSuggestDataEpic,
    fetchTooltipDataEpic,
    finishSearchAndReplaceLoadingEpic,
    getBannerModerationRejectReasonsEpic,
    getGridRecommendationApplyStatusEpic,
    getGroupModerationRejectReasonsEpic,
    getPhrasesReplacePreviewEpic,
    loadBannersPreviewEpic,
    openDuplicateGroupsModalEpic,
    openMinusPhraseSelectorGridModalEpic,
    replacePhrasesEpic,
    requestRowEpic,
    resetGridDataEpic,
    setGridDocumentTitleEpic,
    showMinusPhraseBindSuccessMessageEpic,
    showMinusPhraseUnbindSuccessMessageEpic,
    startBannerAimingEpic,
    submitGridRecommendationEpic,
    switchOnlyFavoriteCampaignsFilter,
    switchToOldInterfaceEpic,
    unbindMinusPhraseToGridGroupsEpic,
    updateAdditionalFilterEpic,
    updateAdjustmentForecast,
    updateCalcTypeFilterEpic,
    updateGridFilterDictEpic,
    updateGridFilterPeriodEpic,
    updateSourceParamsEpic
} from './grid-screen/grid-screen';
import { gridScreenHelpersEpic } from './grid-screen/grid-screen-helpers/grid-screen-helpers';
import { gridScreenNavigationEpic } from './grid-screen/grid-screen-navigation';
import {
    addSmartFilterEpic,
    deleteSmartFilterEpic,
    getGroupFiltersEpic,
    updateSmartFilterEpic,
    updateSmartFilterSuccessEpic
} from './groupFilters/groupFilters';
import {
    acceptDuplicateGroupsItemsEpic,
    changeDuplicateGroupsModalViewStateEpic,
    fetchDuplicateGroupsCampaignSelectorDataItemsEpic
} from './groupsDuplicateSelector/groupsDuplicateSelector';
import {
    applySelectorWizardForGroupsEditEpic,
    cancelGroupEditorRegionsEpic,
    createSmartGroupEpic,
    createTextGroupEpic,
    deleteRetargetingListItemFromGroupEpic,
    getCampaignBasicDataEpic,
    getCpcGroupsForEditEpic,
    getCpmGroupsForEditEpic,
    getGroupsForEditEpic,
    getInternalGroupsForEditEpic,
    getRecommendationsForGroupsEditEpic,
    getRetargetingConditionsForGroupsEditEpic,
    handleGroupsEditMassActionsEpic,
    leaveGroupsEditEpic,
    openGroupFilterInspectorEpic,
    openGroupRetargetingEditorEpic,
    openPhrasesSelectorWizardForGroupsEditEpic,
    openRecommendationsModalForGroupsEditEpic,
    pollingFeedsData,
    resetGroupsEditEpic,
    saveCpmGroupsEpic,
    saveCryptaAudioGenresEpic,
    saveCryptaBehavioralEpic,
    saveCryptaGroupFamilyEpic,
    saveCryptaSocialDemoEpic,
    saveGroupEditorRegionEpic,
    saveGroupMinusPhrasesEditorEpic,
    saveGroupRateCorrectionEditorEpic,
    saveGroupRetargetingEditorEpic,
    saveGroupsEpic,
    saveIndoorMapActionEpic,
    saveInterestsTargetingSetEpic,
    saveInternalGroupsEpic,
    saveOutdoorMapActionEpic,
    updateCryptaAudioGenresEpic,
    updateCryptaBehavioralEpic,
    updateCryptaGroupFamilyEpic,
    updateCryptaSocialDemoEpic,
    updateGroupEditorRegionEpic,
    updateGroupNameEpic,
    updateGroupRetargetingEditorEpic,
    updateGroupTypeEpic,
    updateInterestsTargetingSetEpic,
    updateRetargetingListItemEpic,
    updateShowConditionTypeEpic
} from './groupsEdit/groupsEdit';
import { onAcceptMinusPhraseGroupsMassActionsEpic } from './groupsEdit/massActions/massActions';
import {
    fetchHeaderInfoEpic,
    fetchHeaderWalletInfoEpic,
    fetchInfoBlockDataEpic,
    fetchInfoBlockNewsItemEpic,
    fetchUserAccountsInfoEpic,
    sendFeedbackEpic
} from './header/header';
import {
    openImageSmartCenterEditorEpic,
    saveImageSmartCentersEpic,
    updateImagesSmartCentresEpic
} from './imageSmartCenterEditor/imageSmartCenterEditor';
import {
    getInternalBannersForEditEpic,
    saveInternalBannersEpic,
    scrollToDuplicateInternalBannerEpic,
    updateInternalBannerNameEpic,
    uploadInternalBannerImageEpic
} from './internalBannersEdit/internalBannersEdit';
import { logHelpers } from './log-helpers';
import { logNavigationEpic } from './log-navigation';
import { marketers } from './marketers';
import { metrikaCounterEditorEpic } from './metrikaCounterEditor/metrikaCounterEditor';
import {
    createMinusPhraseListDataEpic,
    deleteMinusPhraseListEpic,
    handleMinusPhraseLibraryColumnsWidthUpdateEpic,
    openMinusPhraseLibraryAddListModalEpic,
    openMinusPhraseLibraryEditListModalEpic,
    requestMinusPhraseLibraryGridRowEpic,
    resetMinusPhraseLibraryEpic,
    updateMinusPhraseListDataEpic
} from './minusPhraseLibrary/minusPhraseLibrary';
import {
    addLibraryListEditorEpic,
    fetchLibraryListsEpic,
    openEditorMinusPhraseLibraryEpic
} from './minusPhrasesEditor/minusPhrasesEditor';
import {
    createMobileAppEpic,
    fetchAppTrackersTemplatesEpic,
    fetchMobileAppEpic,
    fetchMobileAppStoreInfoEpic,
    updateMobileAppEpic
} from './mobile-app';
import { fetchMobileAppsListEpic } from './mobile-apps-list';
import {
    bulkUpdateOrganizationsEpic,
    loadOrganizationForEditEpic,
    loadOrganizationsForEditEpic,
    resetOrganizationsEditorEpic,
    updateOrganizationInBanner
} from './organization/organization';
import { updatePhraseEpic } from './phrases-grid';
import {
    addPhraseToStartPhrasesEpic,
    fetchPhrasesForPhrasesSelectorWizardEpic,
    openPhrasesSelectorWizardEpic,
    submitSelectionWizardEpic,
    submitStartPhraseInputValueEpic
} from './phrasesSelectorWizard/phrasesSelectorWizard';
import {
    fetchPredictorEpic,
    fetchPredictorMapEpic,
    fetchPredictorRecommendationEpic
} from './predictor/predictor';
import {
    fetchPredictorEditor,
    initialPredictorIndoorEditor,
    initialPredictorOutdoorEditor
} from './predictorEditor/predictorEditor';
import { acceptPricesWizardChanges } from './prices-wizard';
import {
    addProductsDataEpic,
    changeProductDataEpic,
    fetchProductsDataEpic
} from './products/products';
import {
    fetchRecommendationsGridDataEpic,
    fetchRecommendationsGridSummaryEpic,
    getRecommendationsGridItemApplyStatusEpic,
    getRecommendationsGridSummaryApplyStatusEpic,
    submitRecommendationsGridDataItemEpic,
    submitRecommendationsGridSummaryEpic
} from './recommendations-grid/recommendations-grid';
import { recommendationsGridHelpersEpic } from './recommendations-grid/recommendations-grid-helpers';
import {
    fetchRecommendationsScreenDataEpic,
    getRecommendationApplyCardStatusEpic,
    submitRecommendationCardEpic
} from './recommendations/recommendations';
import { regionFetchSuggestListEpic } from './regions';
import {
    selectRegionsEditorItemEpic,
    startChangeFilterTextRegionsEditorEpic
} from './regionsEditor/regionsEditor';
import {
    addReportEpic,
    fetchReportsDataEpic
} from './reportsClient/reportsClient';
import { reportHelpersEpic } from './reportsClient/reportsClient-helpers';
import {
    addReportDomainEpic,
    fetchReportsDomainDataEpic
} from './reportsDomain/reportsDomain';
import { reportDomainHelpersEpic } from './reportsDomain/reportsDomain-helpers';
import {
    acceptMassCommonPriceChangesEpic,
    changeCopiedRetargetingRulesTooltipStatusEpic,
    copyRetargetingRulesInfoToClipboardEpic,
    updateRetargetingCommonPriceCellEpic
} from './retargeting/retargeting';
import {
    changeVisitorForecastDataEpic,
    openRetargetingConditionEditorEpic,
    saveAudienceRetargetingConditionAsNewDataEpic,
    saveRetargetingConditionAsNewDataEpic,
    saveRetargetingConditionDataEpic
} from './retargetingConditionEditor/retargetingConditionEditor';
import {
    addRetargetingConditionEpic,
    deleteRetargetingListItemEpic,
    editRetargetingListItemEpic,
    updateRetargetingConditionEpic
} from './retargetingEditor/retargetingEditor';
import { routerLocationChangedEpic } from './router';
import { openTimeTargetingEditorEpic } from './timeTargetingEditor/timeTargetingEditor';
import { welcomeDataEpic } from './welcome';

export const epics = [
    updateSourceParamsEpic,
    fetchSuggestDataEpic,
    fetchGridGroupsCountsEpic,
    requestRowEpic,
    resetGridDataEpic,
    welcomeDataEpic,
    replacePhrasesEpic,
    scrollToDuplicateBannerEpic,
    copyOrganizationBannerEpic,
    clearOrganizationsBannersEpic,
    getPhrasesReplacePreviewEpic,
    fetchRecommendationsGridDataEpic,
    fetchRecommendationsScreenDataEpic,
    fetchRecommendationsGridSummaryEpic,
    submitRecommendationCardEpic,
    getRecommendationApplyCardStatusEpic,
    submitGridRecommendationEpic,
    getGridRecommendationApplyStatusEpic,
    updateMinusPhraseListDataEpic,
    submitRecommendationsGridDataItemEpic,
    submitRecommendationsGridSummaryEpic,
    getRecommendationsGridSummaryApplyStatusEpic,
    getRecommendationsGridItemApplyStatusEpic,
    finishSearchAndReplaceLoadingEpic,
    fetchReportsDataEpic,
    fetchReportsDomainDataEpic,
    addReportEpic,
    addReportDomainEpic,
    fetchTooltipDataEpic,
    commonDataEpic,
    requestAuthorizationData,
    acceptPricesWizardChanges,
    switchToOldInterfaceEpic,
    requestClientMobileAppsDataEpic,
    fetchMobileAppsListEpic,
    submitStartPhraseInputValueEpic,
    submitSelectionWizardEpic,
    addPhraseToStartPhrasesEpic,
    openPhrasesSelectorWizardEpic,
    fetchPhrasesForPhrasesSelectorWizardEpic,
    fetchMobileAppStoreInfoEpic,
    createMobileAppEpic,
    fetchMobileAppEpic,
    redirectToLocationEpic,
    updateAdditionalFilterEpic,
    loadBannersPreviewEpic,
    requestClientFreelancerDataEpic,
    freelancers,
    updateDealsSourceParamsEpic,
    dealDetailEpic,
    updateDealsEpic,
    loadDealsCampaignsEpic,
    clientsDealsLoadEpic,
    acceptRejectDealsEpic,
    requestDealsEpic,
    resetDealsDataEpic,
    updateDocumentTitleEpic,
    setGridDocumentTitleEpic,
    changeLocationHardDataEpic,
    fetchCampaignAndGroupSelectorCampaignsDataEpic,
    fetchCampaignAndGroupSelectorGroupsDataEpic,
    acceptCampaignAndGroupSelectorDataEpic,
    openCampaignAndGroupSelectorEpic,
    selectCampaignAndGroupSelectorCampaignEpic,
    fetchAppTrackersTemplatesEpic,
    sendFeedbackEpic,
    updateBannerCreativeIdEpic,
    updateBannerCpcCreativeIdEpic,
    updateCpmBannerCreativeIdEpic,
    updateMobileAppEpic,
    rejectRequestAuthorizationDataEpic,
    deleteCookieEpic,
    setCookieEpic,
    reloadLocationEpic,
    doFakeAuthEpic,
    switchShowCaptchaStateEpic,
    switchDumpVarsStateEpic,
    getModerationRejectReasons,
    getBannerModerationRejectReasonsEpic,
    getGroupModerationRejectReasonsEpic,
    startBannerAimingEpic,
    routerLocationChangedEpic,
    updateGridFilterDictEpic,
    updateGridFilterPeriodEpic,
    addEntitySuccessEpic,
    editEntitySuccessEpic,
    fetchGroupKeywordsAndRetargetingsEpic,
    changeCopiedDisplayConditionsTooltipStatusEpic,
    changeOpenStateDisplayConditionsEpic,
    copyKeywordsToClipboardEpic,
    getBannersForEditEpic,
    getRecommendationsForBannersEditEpic,
    openRecommendationsModalForBannersEditEpic,
    getRecommendationsForGroupsEditEpic,
    openRecommendationsModalForGroupsEditEpic,
    getBaseInfoForBannerCreationEpic,
    createNewBannerEpic,
    leavePerformanceBannerCreationEpic,
    scrollToDuplicateInternalBannerEpic,
    getInternalBannersForEditEpic,
    saveInternalBannersEpic,
    updateInternalBannerNameEpic,
    uploadInternalBannerImageEpic,
    checkBannersPromocodesEpic,
    cancelBannersEpic,
    getVCardsForEditEpic,
    loadOrganizationsForEditEpic,
    loadOrganizationForEditEpic,
    updateOrganizationInBanner,
    bulkUpdateOrganizationsEpic,
    resetOrganizationsEditorEpic,
    getImagesForEdit,
    fetchInfoBlockDataEpic,
    fetchInfoBlockNewsItemEpic,
    fetchUserAccountsInfoEpic,
    fetchHeaderInfoEpic,
    fetchHeaderWalletInfoEpic,
    getGroupsForEditEpic,
    getCpcGroupsForEditEpic,
    getInternalGroupsForEditEpic,
    updateGroupTypeEpic,
    getCpmGroupsForEditEpic,
    openPhrasesSelectorWizardForGroupsEditEpic,
    openGroupRetargetingEditorEpic,
    saveGroupRetargetingEditorEpic,
    onVideoCreativeCloseEpic,
    regionFetchSuggestListEpic,
    updateBannersContactsForUserEpic,
    updateBannersContactsForUserDomainEpic,
    updateDraftSiteLinksEpic,
    uploadBannerImageEpic,
    saveGroupsEpic,
    saveCpmGroupsEpic,
    saveGroupRateCorrectionEditorEpic,
    saveInterestsTargetingSetEpic,
    updateInterestsTargetingSetEpic,
    saveCryptaSocialDemoEpic,
    updateCryptaSocialDemoEpic,
    saveCryptaGroupFamilyEpic,
    saveCryptaAudioGenresEpic,
    saveOutdoorMapActionEpic,
    saveIndoorMapActionEpic,
    updateCryptaGroupFamilyEpic,
    updateCryptaAudioGenresEpic,
    saveCryptaBehavioralEpic,
    updateCryptaBehavioralEpic,
    leaveGroupsEditEpic,
    getTurbolandingInfoEpic,
    getTurbolandingInfoForSitelinkEpic,
    fetchAdjustmentInfoEpic,
    updateAdjustmentForecast,
    updatePhraseEpic,
    updateCampaignDayBudgetEpic,
    gridScreenHelpersEpic,
    gridScreenNavigationEpic,
    saveSitelinksEpic,
    uploadTextBannerImageByLinkEpic,
    getImageCanvasForEdit,
    AddCalloutsEpic,
    RemoveCalloutsEpic,
    checkBannerHrefStatusEpic,
    saveBannersEpic,
    dealsNavigationEpic,
    dealsHelpersEpic,
    logNavigationEpic,
    logHelpers,
    recommendationsGridHelpersEpic,
    reportHelpersEpic,
    reportDomainHelpersEpic,
    applySelectorWizardForGroupsEditEpic,
    checkBannerSitelinkHrefStatusEpic,
    startChangeFilterTextRegionsEditorEpic,
    cancelGroupEditorRegionsEpic,
    uploadAdBannerImagesEpic,
    uploadAdBannerImageByLinkEpic,
    updateBannerImagesFromGallery,
    validateAdBannerImagesEpic,
    showBannerImagesErrorEpic,
    validateBannerImageFromGalleryEpic,
    selectRegionsEditorItemEpic,
    saveGroupEditorRegionEpic,
    deleteRetargetingListItemEpic,
    getPerformanceCreativesEpic,
    leaveBannersEditEpic,
    updatePerformanceCreativesSearchFieldEpic,
    fetchLibraryListsEpic,
    addLibraryListEditorEpic,
    openMinusPhraseLibraryAddListModalEpic,
    createMinusPhraseListDataEpic,
    pollingFeedsData,
    requestMinusPhraseLibraryGridRowEpic,
    handleMinusPhraseLibraryColumnsWidthUpdateEpic,
    resetMinusPhraseLibraryEpic,
    deleteMinusPhraseListEpic,
    openMinusPhraseLibraryEditListModalEpic,
    switchOnlyFavoriteCampaignsFilter,
    acceptCampaignAndGroupSelectorDataDnaEpic,
    getCampaignBasicDataEpic,
    getRetargetingConditionsForGroupsEditEpic,
    openRetargetingConditionEditorEpic,
    editRetargetingListItemEpic,
    changeVisitorForecastDataEpic,
    saveRetargetingConditionDataEpic,
    updateRetargetingConditionEpic,
    saveRetargetingConditionAsNewDataEpic,
    saveAudienceRetargetingConditionAsNewDataEpic,
    hideRecommendationTooltipEpic,
    openGroupFilterInspectorEpic,
    createTextGroupEpic,
    createSmartGroupEpic,
    columnsSettingsEditorEpic,
    validateBannerPriceEpic,
    updateGridBannerPriceCellEpic,
    openMinusPhraseSelectorGridModalEpic,
    bindMinusPhraseToGridGroupsEpic,
    unbindMinusPhraseToGridGroupsEpic,
    showMinusPhraseBindSuccessMessageEpic,
    showMinusPhraseUnbindSuccessMessageEpic,
    validateBannersPricesEpic,
    saveBannersPricesEpic,
    resetBannersPricesEpic,
    addRetargetingConditionEpic,
    deleteRetargetingListItemFromGroupEpic,
    updateGroupEditorRegionEpic,
    addSmartFilterEpic,
    deleteSmartFilterEpic,
    updateSmartFilterEpic,
    updateSmartFilterSuccessEpic,
    saveFeedFiltersAutobudgetPriorityEpic,
    saveFeedFiltersRateEpic,
    saveFeedFilterRateCellEpic,
    saveFeedFilterPriorityCellEpic,
    setInitialFeedFilterRateEpic,
    setInitialFeedFilterPriorityEpic,
    getGroupFiltersEpic,
    openImageSmartCenterEditorEpic,
    updateImagesSmartCentresEpic,
    prepareBannersBeforeSavingEpic,
    saveImageSmartCentersEpic,
    updateRetargetingListItemEpic,
    updateGroupRetargetingEditorEpic,
    changeGoalsCheckedFromColumnsSettingsEditorEpic,
    fetchGoalsDataEpic,
    openDuplicateGroupsModalEpic,
    fetchDuplicateGroupsCampaignSelectorDataItemsEpic,
    changeDuplicateGroupsModalViewStateEpic,
    acceptDuplicateGroupsItemsEpic,
    openColumnsSettingsEditorEpic,
    saveInternalGroupsEpic,
    fetchClientDev,
    handleBannersEditMassActionsEpic,
    closeAlertGridErrorEpic,
    onGridSourceParamsChangedEpic,
    updateLinkProtocolBannersContactsForUserEpic,
    updateProtocolDraftSiteLinksEpic,
    onAcceptMassActionSiteLinksDataEpic,
    updateCalcTypeFilterEpic,
    onAcceptMassActionsLinkBulkReplacementEditorEpic,
    onAcceptMassActionsLinkBulkPathReplacementEditorEpic,
    onAcceptMassActionsVideoEditorEpic,
    getCampaignsForEditEpic,
    onAcceptMassActionsImageEditorEpic,
    copyRetargetingRulesInfoToClipboardEpic,
    changeCopiedRetargetingRulesTooltipStatusEpic,
    acceptMassCommonPriceChangesEpic,
    onAcceptMassActionsCalloutsEditorEpic,
    saveGroupMinusPhrasesEditorEpic,
    handleGroupsEditMassActionsEpic,
    updateShowConditionTypeEpic,
    onAcceptMinusPhraseGroupsMassActionsEpic,
    saveCampaignRelevantPhrasesEpic,
    saveCampaignChatEpic,
    saveCampaignMetrikaCountersEpic,
    updateGroupNameEpic,
    updateCampaignNameEpic,
    chatListEditorEpic,
    metrikaCounterEditorEpic,
    onSaveMassActionsTextBulkReplacementEditorEpic,
    updateRetargetingCommonPriceCellEpic,
    onAcceptMassActionsLinkDisplayedBulkReplacementEditorEpic,
    updateCampaignDisabledIpsEpic,
    saveCampaignsEpic,
    leaveCampaignsEditEpic,
    onAddTextBannerEpic,
    createNewTextBannerEpic,
    updateCampaignAllowedPageIdsEpic,
    updateCampaignBannedDomainsEpic,
    saveCampaignNotificationEditorEpic,
    saveCampaignExperimentsEditorEpic,
    saveCampaignMetrikaKeyGoalsEditorEpic,
    fetchProductsDataEpic,
    addProductsDataEpic,
    changeProductDataEpic,
    marketers,
    fetchPredictorEpic,
    fetchPredictorRecommendationEpic,
    getBannersAutoGeneratedVideosEpic,
    addEndDateForEditCampaignEpic,
    deleteEndDateForEditCampaignEpic,
    resetGroupsEditEpic,
    saveCampaignStrategyEditorEpic,
    openEditorMinusPhraseLibraryEpic,
    saveCampaignMinusPhrasesEditorEpic,
    saveVisitingCardForEditBannerEpic,
    saveCampaignTimeTargetingEditorEpic,
    openTimeTargetingEditorEpic,
    onDeleteEndDateForDatesIntervalEditorEpic,
    saveVisitingCardForEditCampaignEpic,
    clearBannersForEditBannerEpic,
    getRetargetingConditionsForCampaignsEditEpic,
    saveCampaignRateCorrectionEditorEpic,
    changeBannerTypeAttemptEpic,
    fetchPredictorEditor,
    initialPredictorOutdoorEditor,
    initialPredictorIndoorEditor,
    fetchPredictorMapEpic,
    changeSiteMonitoringFlagForEditCampaignEpic,
    fetchCampaignsGoalsAvailableForKeyGoalsEpic,
    updateCampaignMetrikaCountersEpic,
    fetchVCardMetroStationEpic
];

export const mainEpic = combineEpics(...epics);
